export interface Testimonial {
  content: string;
  name: string;
  position: string;
  rating?: number;
  source: string;
}
export const TESTIMONIALS: Testimonial[] = [
  {
    content:
      'Équipe professionnelle, énergique et efficace. Le travail est réalisé avec attention et le service à la clientèle est excellent du début à la fin.',
    name: 'Mario C.',
    position: 'Client Apex Prestige',
    source: 'Témoignage client',
  },
  {
    content:
      'À mon arrivée, l’extérieur de la maison était complètement transformé : propre, éclatant et impeccable. Très impressionné du résultat.',
    name: 'Robert B.',
    position: 'Client Apex Prestige',
    source: 'Témoignage client',
  },
  {
    content:
      'Mes soffites et mes gouttières avaient vraiment besoin d’amour, et le résultat a dépassé mes attentes. La maison a retrouvé un aspect propre et lumineux. Service rapide, soigné et très professionnel.',
    name: 'Francine M.',
    position: 'Cliente Apex Prestige',
    source: 'Témoignage client',
  },
  {
    content:
      'Équipe ponctuelle et courtoise. Ils ont nettoyé le revêtement et l’entrée de béton, et le résultat est vraiment impeccable. Je recommande sans hésiter à tous ceux qui cherchent à Sherbrooke.',
    name: 'Sylvie T.',
    position: 'Cliente Apex Prestige, Sherbrooke',
    source: 'Témoignage client',
  },
  {
    content:
      'On a fait appel à eux pour le lavage de notre toiture et de nos gouttières. Travail minutieux, aucun dégât sur les plates-bandes, et un suivi impeccable après la job.',
    name: 'Jean-François L.',
    position: 'Client Apex Prestige, Sherbrooke',
    source: 'Témoignage client',
  },
  {
    content:
      'Service exceptionnel du début à la fin. L’équipe a pris le temps de bien expliquer le processus et le prix était juste. Notre revêtement extérieur a l’air neuf.',
    name: 'Chantal D.',
    position: 'Cliente Apex Prestige, Magog',
    source: 'Témoignage client',
  },
  {
    content:
      'Rapide, propre et efficace. Les gars ont fait attention à mes plates-bandes et ont même ramassé les débris avant de partir. Ça fait toute la différence.',
    name: 'Martin P.',
    position: 'Client Apex Prestige, Sherbrooke',
    source: 'Témoignage client',
  },
  {
    content:
      'J’ai fait nettoyer mon entrée pavée et mon patio, et je suis bouche bée par le résultat. On dirait que tout est neuf. Merci à l’équipe pour leur professionnalisme.',
    name: 'Lyne G.',
    position: 'Cliente Apex Prestige, Victoriaville',
    source: 'Témoignage client',
  },
  {
    content:
      'Excellente expérience du début à la fin. Communication claire, prix compétitif et un travail soigné sur nos soffites et fascias. Je n’hésiterai pas à les rappeler.',
    name: 'Alexandre R.',
    position: 'Client Apex Prestige, Sherbrooke',
    source: 'Témoignage client',
  },
];